const Contact = () => {
  return <h1>Contact Om sir</h1>;
};

export default Contact;